import { t } from '~/i18n';

// Device-type keys that have a `device.types.*` translation. The billing endpoint
// returns the (hw-refined) DeviceType value (e.g. 'IXI_PRO', 'WATCHERR', 'GATEWAY'),
// which maps to `device.types.<lowercased>`.
const DEVICE_TYPE_KEYS = new Set<string>([
  'watcherr',
  'wall_mounted_distress_button',
  'emergency_button',
  'regular_button',
  'wristband_distress_button',
  'wearable_tag',
  'equipment_tag',
  'beacon',
  'gateway',
  'eview',
  'twig',
  'ixi_lite',
  'ixi_touch',
  'ixi_black',
  'ixi_pro',
  'api_external',
]);

export const deviceTypeLabel = (deviceType: string): string => {
  const key = deviceType.toLowerCase();
  return DEVICE_TYPE_KEYS.has(key) ? t(`device.types.${key}`) : deviceType;
};

// HCP_APP devices (the HCP mobile app) are not billable hardware — hidden for now.
export const isHiddenDeviceType = (deviceType: string): boolean => deviceType.toUpperCase() === 'HCP_APP';

// HCPs and installers are both "alarm receivers" (residents are "alarm senders"),
// so they're billed on one merged line. Installers fold onto the HCP group key,
// whose label already reads "Alarm receivers".
const PROFILE_GROUPS: Record<string, string> = {
  INSTALLER: 'HEALTHCARE_PROVIDER',
};

export const profileGroup = (profileType: string): string => PROFILE_GROUPS[profileType] ?? profileType;

// Profile types reuse the existing menu labels until dedicated billing copy exists.
const PROFILE_TYPE_LABEL_KEYS: Record<string, string> = {
  HEALTHCARE_PROVIDER: 'menu.dashboard.healthcareProviders',
  RESIDENT: 'menu.dashboard.residents',
};

export const profileTypeLabel = (profileType: string): string => {
  const key = PROFILE_TYPE_LABEL_KEYS[profileType];
  return key ? t(key) : profileType;
};

// Label for the leading "Type" column, reusing existing copy.
export const rowTypeLabel = (kind: 'org' | 'site'): string =>
  t(kind === 'org' ? 'billing.organization' : 'deviceDetail.site');
